<div id='myTeacherDiv'>
  <div class="student-raised-hand-wrapper"
       *ngIf="localUser.accessType === AccessType.STUDENT"
       (click)="raiseHand()"
       title="{{localUser?.isHandRaised ? 'Lower hand' : 'Raise hand'}}"
       [ngClass]="{'on' : localUser?.isHandRaised}">
    <img class="student-raised-hand-icon" src="assets/img/wrtc/student-raised-hand.png"
         alt="student raised hand">
  </div>

  <div class="wrtc-teacher-div h-100">
    <div class="wrtc-teacher row no-gutters h-100" id="local-teacher">
      <div class="wrtc-teacher-label-div local-teacher-label d-flex align-items-center">
        <div class="wrtc-teacher-label text-truncate"
             *ngIf="localUser.accessType === AccessType.TEACHER && isLocalUserConnected">
          {{localUser?.nickname || "Teacher"}}
        </div>
        <div class="wrtc-teacher-label text-truncate"
             *ngIf="localUser.accessType !== AccessType.TEACHER && isLocalUserConnected">
          {{
            (_remoteTeachers[0]?.additionalInfo.roomConnectionStatus !== ConnectionStatus.OFFLINE &&
            _remoteTeachers[0]?.additionalInfo.nickname) ?
              _remoteTeachers[0]?.additionalInfo.nickname :
              "Teacher"
          }}
        </div>

        <div class="ml-auto"
             *ngIf="(localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT) && isLocalUserConnected">

          <div ngbDropdown class="dropdown">
            <button ngbDropdownToggle id="button-basic" type="button" class="video-action-btn mb-0"
                    title="Advanced settings"><i class="fas fa-ellipsis-v"></i></button>
            <ul ngbDropdownMenu id="dropdown-basic"
                class="dropdown-menu cs-dropdown-menu dropdown-menu-right teacher-settings-dropdown" role="menu"
                aria-labelledby="button-basic">
              <li role="menuitem">
                <a class="dropdown-item" href="javascript:void(0)" (click)="openAudioVideoDeviceConfigurationDialog()">
                  <img src="assets/img/wrtc/video-settings.svg" width="20" class="mr-2"
                       alt="Video settings">
                  Audio/ Video Settings
                </a>
              </li>
              <li *ngIf="localUser.accessType !== AccessType.SUPPORT" role="menuitem">
                <a class="dropdown-item" href="javascript:void(0)" (click)="changeTeacherNickName()">
                  <i class="fas fa-pencil mr-2"></i>
                  Edit Name
                </a>
              </li>
              <div class="dropdown-divider"></div>
              <li role="menuitem">
                <a class="dropdown-item" href="javascript:void(0)" [ngClass]="{'show-chat': !classroom.isChatHidden}"
                   (click)="toggleShowChat()">
                  <img src="assets/img/enable-chat.svg" width="20" class="mr-2" alt="Classwide Chat">
                  Send Classwide Chat
                </a>
              </li>
              <div class="dropdown-divider"></div>
              <li role="menuitem">
                <a class="dropdown-item" href="javascript:void(0)" [ngClass]="{'active': isTeachersVideoMuted}"
                   (click)="toggleMuteTeachersVideo()">
                  <i class="fas fa-video mr-2" [ngClass]="{'fa-video-slash': isTeachersVideoMuted}"></i>
                  Mute My Video
                </a>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" href="javascript:void(0)" [ngClass]="{'active': isTeachersAudioMuted}"
                   (click)="toggleMuteTeachersAudio()">
                  <i class="fas fa-microphone mr-2" [ngClass]="{'fa-microphone-slash': isTeachersAudioMuted}"></i>
                  Mute My Audio
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="wrtc-subscriber-controls d-flex flex-column" *ngIf="isLocalUserConnected">
        <button class="video-action-btn" [ngClass]="{'active': localUser.video.isMuted}" title="Camera on/off"
                *ngIf="localUser.accessType === AccessType.TEACHER"
                (click)="toggleMuteTeachersVideo()">
          <i class="fas fa-video" [ngClass]="{'fa-video-slash': localUser.video.isMuted}"></i>
        </button>
        <button class="video-action-btn" title="Microphone on/off"
                *ngIf="localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT"
                [ngClass]="{'active': localUser.audio.isMuted}" (click)="toggleMuteTeachersAudio()">
          <i class="fas fa-microphone" [ngClass]="{'fa-microphone-slash': localUser.audio.isMuted}"></i>
        </button>
      </div>

      <div class="teacher-video-container col h-100" *ngIf="localUser.accessType === AccessType.TEACHER">
        <div class="teacher-video-wrapper d-flex align-items-center h-100" #mediaWrapper>
          <div class="unmute-classroom d-flex justify-content-center align-items-center" *ngIf="classroom.isRoomMutedBecauseOfCurrentUserBlockedMicAndCam">
            <img src="assets/img/wrtc/speaker-off.svg" width="90"
                 alt="Speaker off"
                 style="cursor: pointer"
                 title="Click to enable AudioCheckManager"
                 (click)="handleClassroomUnmuteButtonClick()">
          </div>
        </div>
      </div>

      <ng-container *ngFor="let teacher of _remoteTeachers">
        <div *ngIf="teacher.additionalInfo.roomConnectionStatus !== ConnectionStatus.OFFLINE"
             class="teacher-video-container col h-100">
          <button type="submit" class="video-action-btn fa fa-sign-out teacher-sign-out" title="Expel Teacher"
                  (click)="expelTeacher(teacher.id)"
                  *ngIf="(localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT)">
          </button>
          <app-remote-teacher [teacher]="teacher"
               class="teacher-video-wrapper d-flex align-items-center h-100"
               [ngClass]="{'teacher-video-mute': teacher.additionalInfo.video.isMuted || !isCurrentUserOnline}">
          </app-remote-teacher>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!--notifications of private talk-->
<div class="notifications-of-private-talk" *ngIf="classroom.privateTalkInfo.isStarted">
  <div class="notification-wrap"
       *ngIf="localUser.accessType === AccessType.STUDENT && classroom.privateTalkInfo.participants[localUser.id]">
    The teacher is talking privately with you.
  </div>
  <div class="notification-wrap"
       *ngIf="(localUser.accessType === AccessType.STUDENT && !classroom.privateTalkInfo.participants[localUser.id])">
    The teacher is talking privately with another student and will be back with you shortly.
  </div>
  <div class="notification-wrap" *ngIf="localUser.accessType === AccessType.OBSERVER">
    The teacher is talking privately with student.
  </div>
</div>

